import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Chip, Tooltip, } from '@mui/material';
import { CreditCard as CreditCardIcon } from '@mui/icons-material';
import { useOrganization } from '../hooks/useOrganization';
import { SubscriptionTier } from '../../../../common/subscriptionTypes';
export const CompactUsageIndicator = ({ showDetails = false }) => {
    const organization = useOrganization();
    const subscription = organization?.subscription;
    const usage = organization?.usage;
    if (!subscription || !usage) {
        return null;
    }
    const creditsRemaining = usage.remainingCredits;
    const isEnterpriseTier = subscription.tier === SubscriptionTier.ADVANCED;
    const isUnlimited = isEnterpriseTier || usage.limits.scoringCredits === -1;
    const getTierColor = (tier) => {
        switch (tier) {
            case SubscriptionTier.FREE: return 'default';
            case SubscriptionTier.STARTER: return 'primary';
            case SubscriptionTier.ADVANCED: return 'success';
            default: return 'default';
        }
    };
    const getCreditsColor = () => {
        if (isUnlimited)
            return 'success.main';
        if (creditsRemaining <= 0)
            return 'error.main';
        if (creditsRemaining <= 2)
            return 'warning.main';
        return 'text.primary';
    };
    const getCreditsText = () => {
        if (isUnlimited)
            return 'Unlimited';
        return `${creditsRemaining} credits`;
    };
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Tooltip, { title: `You have ${getCreditsText()} remaining this month`, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(CreditCardIcon, { sx: {
                                fontSize: 16,
                                color: getCreditsColor(),
                                opacity: 0.8
                            } }), _jsx(Typography, { variant: "body2", sx: {
                                color: getCreditsColor(),
                                fontWeight: 500,
                                fontSize: '0.875rem'
                            }, children: getCreditsText() })] }) }), showDetails && (_jsx(Chip, { size: "small", label: subscription.tier === SubscriptionTier.FREE ? 'Free' :
                    subscription.tier === SubscriptionTier.STARTER ? 'Starter' : 'Advanced', color: getTierColor(subscription.tier), sx: { fontSize: '0.75rem', height: 20 } }))] }));
};
